import React, { useCallback, useState } from 'react';
import moment from 'moment';
import { useController, useFormContext } from 'react-hook-form';
import WorkplaceCalendarModal from '../../../Calendar/WorkplaceCalendarModal';
import TopFieldContent from '../TopFieldContent';
import ErrorMessage from '../ErrorMessage';
import useFormName from '../../../../Hooks/useFormName';
import { joinClasses } from '../../../../Utils/className.util';
// @ts-expect-error
import styles from './CalendarInputField.module.scss';
import FormContainerContextProvider from '../../../../Services/FormContainerContext';

interface Props {
	name: string;
	label?: string;
	patientId: string;
	workplaceId: string;
	className?: string;
	isRequired?: boolean;
	caseId?: string;
	closeOnSuccess?: boolean;
}

const CalendarInputField: React.FC<Props> = ({
	name,
	label,
	patientId,
	workplaceId,
	caseId,
	isRequired = false,
	className,
	closeOnSuccess,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();
	const [isModalOpened, setIsModalOpened] = useState(false);
	const [visibleValue, setVisibleValue] = useState();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: '',
	});

	const toggleIsModalOpened = useCallback(() => {
		setIsModalOpened(prevIsOpen => !prevIsOpen);
	}, []);

	return (
		<div className={className}>
			<TopFieldContent label={label} isRequired={isRequired} />
			<div
				onClick={toggleIsModalOpened}
				className={joinClasses([
					styles.field,
					Boolean(error) ? styles.invalid : '',
				])}>
				{visibleValue ? moment(visibleValue).format('DD.MM.YYYY HH:mm') : ''}
			</div>
			<FormContainerContextProvider name={''}>
				<WorkplaceCalendarModal
					opened={isModalOpened}
					onClose={toggleIsModalOpened}
					patientId={patientId}
					workplaceId={workplaceId}
					caseId={caseId}
					onEventIsCreated={response => {
						if (response.data) {
							field.onChange(
								// @ts-expect-error
								response.data.id,
							);
							// @ts-ignore
							setVisibleValue(response.data.dateFrom);
							if (closeOnSuccess) toggleIsModalOpened();
						}
					}}
				/>
			</FormContainerContextProvider>
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);
};

export default CalendarInputField;
